import React from 'react';
import { Button, SearchInput, Select, Sym } from '../../../components/app2';

/**
 * Filtros del portal del empleado (rediseño jul-2026): búsqueda por periodo +
 * mes + año, en una sola fila como en el diseño.
 *
 * Se conservan los tres filtros de la versión anterior (el diseño solo dibuja
 * mes y año) junto con "Limpiar filtros" y el indicador de filtros activos.
 */

const MONTHS = [
  { value: '', label: 'Todos los meses' },
  { value: '01', label: 'Enero' },
  { value: '02', label: 'Febrero' },
  { value: '03', label: 'Marzo' },
  { value: '04', label: 'Abril' },
  { value: '05', label: 'Mayo' },
  { value: '06', label: 'Junio' },
  { value: '07', label: 'Julio' },
  { value: '08', label: 'Agosto' },
  { value: '09', label: 'Septiembre' },
  { value: '10', label: 'Octubre' },
  { value: '11', label: 'Noviembre' },
  { value: '12', label: 'Diciembre' },
];

const PayrollFilterToolbar = ({
  selectedMonth,
  selectedYear,
  searchTerm,
  onMonthChange,
  onYearChange,
  onSearchChange,
  onClearFilters,
}) => {
  const currentYear = new Date().getFullYear();
  const years = [
    { value: '', label: 'Todos los años' },
    ...Array.from({ length: 5 }, (_, i) => ({
      value: String(currentYear - i),
      label: String(currentYear - i),
    })),
  ];

  const hasActiveFilters = Boolean(selectedMonth || selectedYear || searchTerm);

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 14, alignItems: 'center' }}>
      <SearchInput
        value={searchTerm}
        onChange={(e) => onSearchChange?.(e?.target?.value)}
        placeholder="Buscar periodo…"
        title="Busca por periodo, folio o UUID"
        style={{ flex: 1, minWidth: 190, padding: '9px 13px', borderRadius: 9 }}
        aria-label="Buscar recibo por periodo, folio o UUID"
      />

      <Select
        value={selectedMonth}
        onChange={(e) => onMonthChange?.(e?.target?.value)}
        aria-label="Filtrar por mes"
        style={{ width: 'auto', minWidth: 160, padding: '9px 13px', borderRadius: 9, fontSize: '.88rem', background: 'var(--surface)' }}
      >
        {MONTHS.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
      </Select>

      <Select
        value={selectedYear}
        onChange={(e) => onYearChange?.(e?.target?.value)}
        aria-label="Filtrar por año"
        style={{ width: 'auto', minWidth: 130, padding: '9px 13px', borderRadius: 9, fontSize: '.88rem', background: 'var(--surface)' }}
      >
        {years.map((y) => <option key={y.value} value={y.value}>{y.label}</option>)}
      </Select>

      {hasActiveFilters ? (
        <Button variant="outline" size="sm" icon="close" onClick={onClearFilters}>
          Limpiar filtros
        </Button>
      ) : (
        <span
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            font: "500 .8rem 'Hanken Grotesk'", color: 'var(--muted)',
          }}
        >
          <Sym name="filter_alt" size={16} />
          Sin filtros
        </span>
      )}
    </div>
  );
};

export default PayrollFilterToolbar;
